module.exports = __webpack_public_path__ + "813ddda972e625633f5decf5f1bc3b81.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/share-princess-3.png
// module id = 497
// module chunks = 0